// Configuration for the application
const config = {
    // API configuration
    api: {
        // Base URL for API requests
        // In development with React's built-in proxy, use relative paths
        // For direct connections or production, use the full URL
        baseUrl: process.env.NODE_ENV === 'production'
            ? process.env.REACT_APP_API_URL || 'https://your-production-api.com/api'
            : 'http://127.0.0.1:8000/api',
    }
};

export default config;
